import { render } from "./AdminSettingsScreen.vue?vue&type=template&id=67b68fa7&scoped=true"
import script from "./AdminSettingsScreen.vue?vue&type=script&lang=js"
export * from "./AdminSettingsScreen.vue?vue&type=script&lang=js"

import "./AdminSettingsScreen.vue?vue&type=style&index=0&id=67b68fa7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b68fa7"]])

export default __exports__